import { createTheme } from '@mui/material';
import { typography } from './tokens';
import { colorSchemes } from './schemes';
import * as components from './components';

export const theme = createTheme({
  colorSchemes,
  typography,
  // shadows,
  components,
});
